import React from "react";
import {renderRichText} from "gatsby-source-contentful/rich-text";

export default function PlainTextWithTitle(props) {
    return (
        <section key={props.key} className={'plain-text-with-title-section'}>
            <div className="container">
                <div className="flex-row row align-items-center">
                    <div className="col-lg-6">
                        {props.content.smallTitle &&
                            <div className={'h1-subtitle'}>{props.content.smallTitle}</div>
                        }
                        <h1>{props.content.title}</h1>
                    </div>
                    <div className="col-lg-6 text-muted">
                        {renderRichText(props.content.body)}
                    </div>
                </div>
            </div>
        </section>
    )
}
